module.exports = __webpack_public_path__ + "assets/img/loginBg.18e190bc.png";